import _classCallCheck from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/createClass";
var Integer = /*#__PURE__*/function () {
  function Integer(value) {
    _classCallCheck(this, Integer);
    this.value = value;
  }
  _createClass(Integer, [{
    key: "intValue",
    value: function intValue() {
      return this.value;
    }
  }, {
    key: "compareTo",
    value: function compareTo(o) {
      if (this.value < o) return -1;
      if (this.value > o) return 1;
      return 0;
    }
  }], [{
    key: "compare",
    value: function compare(x, y) {
      if (x < y) return -1;
      if (x > y) return 1;
      return 0;
    }
  }, {
    key: "isNan",
    value: function isNan(n) {
      return Number.isNaN(n);
    }
  }, {
    key: "valueOf",
    value: function valueOf(value) {
      return new Integer(value);
    }
  }]);
  return Integer;
}();
export { Integer as default };